var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.serverRender)?[_vm._t("default")]:[(_vm.isIntersect)?[_vm._t("default")]:_c('div',{class:_vm.$style.inner},[_c('ComponentLoadingDots',{class:_vm.$style.svg})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }